import React from 'react';

import { useStopEventInvitesState } from './StopEventInvitesContext';
import StopEventInvitesLoader from './StopEventInvitesLoader';

import styles from './Event.module.scss';

const StopEventInvites = ({ id }) => {
  const state = useStopEventInvitesState();

  return (
    <>
      <StopEventInvitesLoader id={id} />
      <div id={styles.stopEventInvitesMessageContainer}>
        <h3 id={styles.stopEventInvitesMessage}>{state?.stopEventInvites?.pageMessage}</h3>
      </div>
    </>
  );
};

export default StopEventInvites;
